import { Link } from 'react-router-dom'
import { useContext } from 'react';

import { AuthContext } from '../../contextos/authContext'
import { CONSTANTES } from '../../config/constantes'

import { servDownloadFilePorFilename } from '../../servicos/servicosEmRotasPrivadas/download';
import { servInvalidarToken } from '../../servicos/servicosEmRotasPrivadas/login';

function MenuRender({ botoesERotas }) {

    const { signed } = useContext(AuthContext);

    return (

        <div className='d-flex justify-content-start justify-content-sm-center bg-color-menu'>
            <nav className="navbar navbar-expand-sm p-1">
                <div className="container-fluid">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navBarmenuPrincipal"
                        aria-controls="navBarmenuPrincipal"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div
                        className="collapse navbar-collapse"
                        id="navBarmenuPrincipal"
                    >
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {botoesERotas.map((menu) =>
                                <li key={menu.id} className="nav-item dropdown">
                                    <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        id="navbarDropdown"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        {menu.nome}
                                    </a>
                                    <ul
                                        className="dropdown-menu bg-color-menu"
                                        aria-labelledby="navbarDropdown"
                                    >
                                        {menu.submenus.map((submenu) =>
                                            submenu.linkExterno ?
                                                <li key={submenu.id}>
                                                    <button
                                                        className="dropdown-item"
                                                        type="button"
                                                        onClick={() => servDownloadFilePorFilename(CONSTANTES.FILENAME_FICHA_INDICADORES)}
                                                    >
                                                        {submenu.submenu}
                                                    </button>
                                                </li>
                                                :
                                                <li key={submenu.id}>
                                                    <Link className='dropdown-item' to={submenu.linkTo}>{submenu.submenu}</Link>
                                                </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                            {signed &&
                                <>
                                    <li className="nav-item">
                                        <button
                                            className="nav-link"
                                            type="button"
                                            onClick={() => servDownloadFilePorFilename(CONSTANTES.FILENAME_MANUAL_DO_SISTEMA)}
                                        >
                                            Manual de Uso
                                        </button>
                                    </li>

                                    {process.env.REACT_APP_BUTTON_LIMPA_CACHE === "true" && (
                                        <li className="nav-item">
                                            <button
                                                className="nav-link"
                                                type="button"
                                                onClick={() => servInvalidarToken()}
                                            >
                                                Limp Info Login
                                            </button>
                                        </li>
                                    )}
                                </>
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        </div>

    )
}

export default MenuRender;
